export class Message {
    mine: boolean;
    text: string;
    time: Date;
    isSeen: boolean;
}
